import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { userApi } from "redux/user/api";
import {
  STORAGE_AUTH_TOKEN,
  STORAGE_USER_COUNTRY,
  STORAGE_USER_IP,
} from "constants/variables";
import * as authSelectors from "redux/auth/selectors";
import * as userSelectors from "redux/user/selectors";
import { makeLangUrl } from "helpers/makeLangUrl";
import { getLocalStorageItem } from "utils/localStorage";
import { useAuthStore } from "stores/auth";
import { useSettingsStore } from "stores/settings";
import url from "../url/index";

type PublicRouteProps = {
  children: JSX.Element;
};

const PublicRoute = (props: PublicRouteProps) => {
  const { children } = props;
  const token = getLocalStorageItem(STORAGE_AUTH_TOKEN);
  const currentCountry = getLocalStorageItem(STORAGE_USER_COUNTRY);
  const currentUserIP = getLocalStorageItem(STORAGE_USER_IP);
  const { refetch, isSuccess } = userApi.useGetProfileQuery(
    token ? "" : skipToken,
  );
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const isBanned = useSelector(userSelectors.isBanned);
  const serviceErrorState = useSettingsStore((state) => state.serviceError);
  const navigate = useNavigate();

  const setIsAfterAuthCheck = useAuthStore(
    (state) => state.setIsAfterAuthCheck,
  );

  useEffect(() => {
    if (token) {
      setTimeout(() => refetch());
    } else {
      setTimeout(() => {
        setIsAfterAuthCheck(true);
      }, 100);
    }
    if (serviceErrorState) {
      navigate(makeLangUrl(url.routes.pages.serviceError()));
    }
    if (
      currentCountry === "US" ||
      currentCountry === "GB" ||
      currentCountry === "UK" ||
      currentCountry === "SE" ||
      (currentCountry === "NL" &&
        currentUserIP !== "167.172.46.45" &&
        currentUserIP !== "165.22.198.21" &&
        currentUserIP !== "165.22.198.75" &&
        currentUserIP !== "165.22.202.233" &&
        currentUserIP !== "165.22.193.33")
    ) {
      navigate(makeLangUrl(url.routes.pages.notAvailablePage()));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceErrorState, currentCountry]);

  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        setIsAfterAuthCheck(true);
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return isAuthenticated && isBanned ? (
    <Navigate to={makeLangUrl("profile/banned")} />
  ) : (
    children
  );
};

export default PublicRoute;
